// src/composables/useOnlineStatus.js
// Single binary connection state — online or offline. Nothing else.
import { isOnline } from '@/services/healthCheck';

export function useOnlineStatus() {
  return { isOnline };
}
